import { isBoolean, isEmpty, isNaN, isNumber } from 'lodash';

export default function isBlank(value: any) {
  return (isEmpty(value) && !isNumber(value) && !isBoolean(value)) || isNaN(value);
}
